<div
  style="border-radius: 16px; background: #FFF; padding: 24px 24px 28px 24px; display: flex; flex-direction: column; align-items: flex-start; gap: 10px; width: 100%; max-width: 429px; max-height: calc(90vh - 60px); overflow-y: auto; box-shadow: 0 20px 50px rgba(0,0,0,0.15);">

  <div class="flex flex-col gap-12 items-start w-full">

    <div class="flex flex-col gap-7 items-start w-full">

      <div class="flex flex-col gap-1.25 items-start font-body" style="color: #212121;">
        <p style="font-size: 15px; font-weight: 700; line-height: normal;">
          Ingresar en tu cuenta
        </p>
        <p style="font-size: 12px; font-weight: 400; line-height: normal;">
          Si tienes una cuenta,
          <button class="cursor-pointer bg-transparent border-none p-0 hover:text-rojo-brillante! hover:underline" style="font-size: 12px; color: #212121;" (click)="goToLogin()">
            Iniciar sesión
          </button>
        </p>
      </div>

      <div class="flex flex-col items-start w-full gap-4.25">

        <div class="flex flex-col gap-1 items-start w-full">
          <label class="auth-field-label">E-Mail</label>
          <input class="auth-input" type="email" placeholder="Ingresa tu mail" [(ngModel)]="email" name="email"
            autocomplete="email" />
        </div>

        <div class="flex flex-col gap-0.75 items-start w-full">
          <label class="auth-field-label">Contraseña</label>
          <input class="auth-input" type="password" placeholder="Ingresa tu contraseña" [(ngModel)]="password"
            name="password" autocomplete="new-password" />
        </div>

        <div class="flex flex-col gap-0.75 items-start w-full">
          <label class="auth-field-label">Confirmar contraseña</label>
          <input class="auth-input" type="password" placeholder="Ingresa tu contraseña" [(ngModel)]="confirmPassword"
            name="confirmPassword" />
        </div>

        <div class="flex gap-2 items-end w-full">
          <div class="flex flex-col gap-0.75 items-start flex-1">
            <label class="auth-field-label">Nombre</label>
            <input class="auth-input" type="text" placeholder="Ingresa tu nombre" [(ngModel)]="nombre" name="nombre" />
          </div>
          <div class="flex flex-col gap-0.75 items-start flex-1">
            <label class="auth-field-label">Apellido</label>
            <input class="auth-input" type="text" placeholder="Ingresa tu apellido" [(ngModel)]="apellido"
              name="apellido" />
          </div>
        </div>

        <div class="flex flex-col gap-0.75 items-start w-full">
          <label class="auth-field-label">País de residencia</label>
          <div class="select-wrapper">
            <select class="auth-select" [(ngModel)]="pais" name="pais">
              @for (p of paises; track p) {
              <option [value]="p">{{ p }}</option>
              }
            </select>
            <svg class="arrow" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5.5 6L10 1" stroke="#212121" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="flex flex-col gap-0.75 items-start w-full">
          <label class="auth-field-label">Teléfono</label>
          <div class="flex gap-2 items-center w-full">
            <div class="select-wrapper" style="width: 80px; flex-shrink: 0;">
              <select class="auth-select" [(ngModel)]="codigoPais" name="codigoPais">
                @for (c of codigos; track c) {
                <option [value]="c">{{ c }}</option>
                }
              </select>
              <svg class="arrow" width="11" height="7" viewBox="0 0 11 7" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5.5 6L10 1" stroke="#212121" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <input class="auth-input flex-1" type="tel" placeholder="Teléfono" [(ngModel)]="telefono" name="telefono" />
          </div>
        </div>

        <div class="flex gap-2 items-end w-full">
          <div class="flex flex-col gap-0.75 items-start" style="width: 110px; flex-shrink: 0;">
            <label class="auth-field-label">Tipo de documento</label>
            <div class="select-wrapper">
              <select class="auth-select" [(ngModel)]="tipoDoc" name="tipoDoc">
                @for (t of tiposDoc; track t) {
                <option [value]="t">{{ t }}</option>
                }
              </select>
              <svg class="arrow" width="11" height="7" viewBox="0 0 11 7" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5.5 6L10 1" stroke="#212121" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div class="flex flex-col gap-0.75 items-start flex-1">
            <label class="auth-field-label">Número de DNI</label>
            <input class="auth-input" type="number" placeholder="Número de DNI" [(ngModel)]="numDoc" name="numDoc" />
          </div>
        </div>

        <div class="flex gap-2 items-end w-full">
          <div class="flex flex-col gap-0.75 items-start flex-1">
            <label class="auth-field-label">Fecha de nacimiento</label>
            <input class="auth-input" type="text" placeholder="DD/MM/AA" [(ngModel)]="fechaNac" name="fechaNac" />
          </div>
          <div class="flex flex-col gap-0.75 items-start flex-1">
            <label class="auth-field-label">Género</label>
            <div class="select-wrapper">
              <select class="auth-select" [(ngModel)]="genero" name="genero">
                <option value="" disabled selected>Selecciona un género</option>
                @for (g of generos; track g) {
                <option [value]="g">{{ g }}</option>
                }
              </select>
              <svg class="arrow" width="11" height="7" viewBox="0 0 11 7" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5.5 6L10 1" stroke="#212121" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>

      </div>

      <div class="captcha-box" style="margin-bottom: 12px;">
        <div class="captcha-check" [class.checked]="captchaChecked" (click)="captchaChecked = !captchaChecked"></div>
        <span class="captcha-label">No soy robot</span>
        <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/recaptcha-logo.png" alt="reCAPTCHA"
          class="captcha-logo" />
      </div>

      <div class="checkbox-row">
        <div class="sq-check" [class.checked]="aceptaInfo" (click)="aceptaInfo = !aceptaInfo"></div>
        <span class="check-label">
          Acepto recibir información de ofertas, promociones, concursos y servicios por correo electrónico, sms y
          equivalentes
        </span>
      </div>

      <div class="checkbox-row">
        <div class="sq-check" [class.checked]="aceptaPoliticas" (click)="aceptaPoliticas = !aceptaPoliticas"></div>
        <span class="check-label">
          Acepto la <a href="#">Política de compra</a>, <a href="#">Términos de uso</a> y <a href="#">Políticas de
            cookies</a>
          de DEPORTIVO MUNICIPAL S.A y declaro que he sido informado sobre su
          <a href="#">Política de privacidad</a>, por lo tanto, autorizo que mis datos sean tratados de acuerdo con la
          misma
        </span>
      </div>

    </div>

    <button
      class="font-display text-white uppercase cursor-pointer transition-colors duration-200 bg-rojo-brillante border-0 h-9 text-[20px] w-full rounded-2xl"
      style="padding: 0 40px; line-height: 20px;" (click)="register()">
      Ingresar
    </button>

  </div>
</div>
